import { Pipe, PipeTransform } from "@angular/core";
import { formatDatetime } from "@ponder-shared/utils/general";

@Pipe({
    name: "datetime",
    standalone: true
})
export class FormatDateTimePipe implements PipeTransform {
    constructor() {

    }

    public transform(value?: Date, localTime?: boolean): string {
        if (value) {
            return formatDatetime(value, localTime);
        } else {
            return "?";
        }
    }
}